module.exports = __webpack_public_path__ + "js/0.60429481.worker.js"